import React, { useEffect } from "react";
import Aos from "aos";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
  RouterProvider,
} from "react-router-dom";
import RootLayout from "./layout/RootLayout";
import {
  Home,
  AboutPage,
  ProjectsPage,
  ContactPage,
  ProjectDetails,
  ProjectsByCategory,
  ServicesPage,
  SingleService,
} from "./pages";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<RootLayout />}>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/projects" element={<ProjectsPage />} />
      <Route path="/projects/:category" element={<ProjectsByCategory />} />
      <Route path="/projects/:category/:title" element={<ProjectDetails />} />
      <Route path="/services" element={<ServicesPage />} />
      <Route path="/services/:title" element={<SingleService />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Route>
  )
);

function App() {
  useEffect(() => {
    Aos.init();
    Aos.refresh();
  }, []);
  return <RouterProvider router={router} />;
}

export default App;
